// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const SettingsIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path d="M12.01 14.97c-1.68 0-3.04-1.31-3.04-2.96S10.33 9.04 12 9.04c1.69 0 3.02 1.32 3.02 2.97S13.7 14.97 12 14.97" />
      <path
        d="M21.7 14.49c-.21-.32-.5-.63-.88-.83q-.44-.24-.66-.67c-.55-.9-.23-2.1.68-2.63 1.08-.6 1.42-1.93.8-2.97l-.72-1.24c-.61-1.04-1.95-1.4-3.02-.8-.94.5-2.15.17-2.7-.72q-.27-.45-.25-.92c.04-.41-.1-.8-.29-1.12-.4-.65-1.11-1.09-1.9-1.09h-1.52c-.78.02-1.5.44-1.9 1.1-.2.3-.32.7-.3 1.1q.02.49-.25.93c-.54.9-1.76 1.23-2.69.72-1.07-.6-2.4-.24-3.03.8L2.36 7.4c-.62 1.04-.27 2.37.79 2.97.91.54 1.23 1.72.7 2.63-.19.28-.38.52-.68.67-.36.2-.69.51-.86.83-.4.65-.37 1.47.02 2.15l.74 1.26c.4.67 1.14 1.1 1.91 1.1.37 0 .8-.11 1.14-.32q.41-.25.95-.24c1.06 0 1.95.87 1.97 1.9 0 1.22.99 2.16 2.23 2.16h1.46c1.24 0 2.22-.94 2.22-2.15.04-1.04.93-1.91 1.99-1.91q.52-.01.94.24c.35.2.76.31 1.14.31.76 0 1.5-.42 1.9-1.09l.75-1.26c.39-.7.42-1.5.02-2.15"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default SettingsIcon;
